import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCurrentUserParams } from "../../Backend";
import { TopBar } from "../";
import { WebRoutes } from "../../Constants";
import { setUserCredentials } from "../../Reducer";
import "./PrivateRoute.scss";

export function PrivateRoute({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loged, setLoged] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    isLoged();
  }, []);

  const isLoged = async () => {
    setLoading(true);
    var data = await getCurrentUserParams();

    if (data.success) {
      const userData = {
        ...data.data,
      };
      dispatch(setUserCredentials(userData));
      setLoged(true);
    }
    else {
      navigate(WebRoutes.EntryPage);
    }

    setLoading(false);
  };

  const changeLang = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="private-route-container">
      {loading === false && loged ? (
        <div className="main-container">
          <TopBar changeLang={changeLang} />
          <div className="child-container">{children}</div>
        </div>
      ) : (
        <div className="loader-container">
          <div className="loader" />
        </div>
      )}
    </div>
  );
}
